import React, { createContext, useContext } from 'react';

import { usePartNrAssignment, PartNrAssignment } from './usePartNrAssignment';

const AssignmentContext = createContext<PartNrAssignment | null>(null);

export function AssignmentProvider({ children }: { children: React.ReactNode }) {
    const assignment = usePartNrAssignment();
    return (
        <AssignmentContext.Provider value={assignment}>
            {children}
        </AssignmentContext.Provider>
    );
}

export function useAssignment(): PartNrAssignment {
    const ctx = useContext(AssignmentContext);
    if (!ctx) throw new Error('useAssignment must be used within an AssignmentProvider');
    return ctx;
}
